import type {UnitEconomics} from '@ozon-ai/ozon/contracts';
import type {UnitEconomicsAmountMode} from '../types';

export function netBillableUnits(row: UnitEconomics): number {
	return row.deliveredUnits - row.returnedUnits;
}

export function scaleAmount(
	value: number | null,
	mode: UnitEconomicsAmountMode,
	netUnits: number,
): number | null {
	if (value == null) return null;
	if (mode === 'period') return value;
	if (netUnits <= 0) return null;
	return value / netUnits;
}
